import { dashboardResetQuery } from '@/modules/dashboard/dashboardActions';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export const useResetQueryMutation = () => {
	const dispatch = useDispatch();

	const mutate = useCallback(() => {
		dispatch(dashboardResetQuery());
	}, [dispatch]);

	return { mutate };
};
